import {
    CLICK_HERE_TO_SELECT,
    DELIVERY_TAB_LABELS,
    SELECTED_DELIVERY_TAB,
} from "@cart-client/constants/CartDeliverySpeed";
import { RenderingDetails } from "@swiggy-private/cart-types";
import { DELIVERY_SECTION_ELEMENT } from "@swiggy-private/checkout-core";
import { format } from "@swiggy-private/js-utils";

export const getDeliverySectionA11yLabel = (
    renderDetail: Omit<RenderingDetails, "children">,
    selectedSection: DELIVERY_SECTION_ELEMENT | null,
) => {
    const label = DELIVERY_TAB_LABELS[renderDetail?.type?.toUpperCase() as DELIVERY_SECTION_ELEMENT];

    if (selectedSection === renderDetail?.type?.toUpperCase()) {
        return format(SELECTED_DELIVERY_TAB, label);
    }

    return format(CLICK_HERE_TO_SELECT, label);
};
